import en from "./en";
import sk from "./sk";

export default {
  en,
  sk
};
